'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _rule = require('./rule');

var _rule2 = _interopRequireDefault(_rule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (name, token) {
	if (/\s+/.test(token)) {
		token = '"' + token + '"';
	}
	return (0, _rule2.default)(name, token);
};


//////////////////
// WEBPACK FOOTER
// ./~/jspeech/lib/stringify/types/word.js
// module id = 204
// module chunks = 0